import type { FC } from "react";
import Icon from "@ch/components/Icons/Icon";
import { useSelector } from "react-redux";
import type { AppState } from "@ch/redux-store/root-reducer";

interface Props {
  message: string;
  createdAt?: string;
}

const UserChatBubble: FC<Props> = ({ message, createdAt }) => {
  const userImage = useSelector((s: AppState) => s.user.currentUser?.image);
  const formatTime = (iso?: string) => {
    if (!iso) return "";
    const s = new Date(iso).toLocaleTimeString(undefined, {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
    return s.replace(/\b(am|pm)\b/i, (m) => m.toUpperCase());
  };

  return (
    <div className="mb-8 flex items-start justify-end pl-[32px] md:pl-[72px]">
      <div className="max-w-full">
        <div className="max-w-full overflow-hidden rounded-2xl border border-orange px-3 py-2">
          <p className="whitespace-pre-wrap break-all text-sm text-ink-900 md:text-lg">
            {message}
          </p>
        </div>
        <p className="mt-2 text-right text-base text-ink-700">
          {formatTime(createdAt)}
        </p>
      </div>

      <div className="ml-1.5 h-[22px] w-[22px] shrink-0 overflow-hidden rounded-full md:ml-3 md:h-[42px] md:w-[42px]">
        {userImage ? (
          <img
            alt="user"
            className="h-full w-full rounded-full object-cover"
            src={userImage}
          />
        ) : (
          <div className="flex h-full w-full items-center justify-center rounded-full bg-gray-200 text-gray-500">
            <Icon name="user" size={18} />
          </div>
        )}
      </div>
    </div>
  );
};

export default UserChatBubble;
